'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface LiveChatButtonProps {
  language: 'en' | 'ar';
}

const LiveChatButton = ({ language }: LiveChatButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Chat Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 w-16 h-16 bg-brand-purple text-white rounded-full shadow-elevated hover:bg-opacity-90 transition-all duration-base flex items-center justify-center z-40 animate-pulse-glow"
        aria-label="Open live chat"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={28} variant="solid" />
      </button>

      {/* Chat Modal */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-80 bg-card rounded-lg shadow-elevated border border-border overflow-hidden z-40 animate-fade-in">
          <div className="bg-gradient-to-r from-primary to-secondary text-white p-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon name="ChatBubbleLeftRightIcon" size={24} variant="solid" />
              <span className="font-headline font-bold">
                {language === 'en' ? 'Live Chat' : 'الدردشة المباشرة'}
              </span>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="hover:bg-white/20 rounded p-1 transition-colors duration-base"
            >
              <Icon name="XMarkIcon" size={20} variant="outline" />
            </button>
          </div>
          <div className="p-6 space-y-4">
            <p className="text-text-secondary text-sm">
              {language === 'en' ?'Our support team is ready to help you with any questions about moving services in Kuwait.' :'فريق الدعم لدينا جاهز لمساعدتك في أي أسئلة حول خدمات النقل في الكويت.'}
            </p>
            <div className="space-y-3">
              <a
                href="tel:69911181"
                className="flex items-center gap-3 p-3 bg-muted rounded-lg hover:bg-primary/10 transition-colors duration-base"
              >
                <Icon name="PhoneIcon" size={20} variant="solid" className="text-secondary" />
                <div>
                  <p className="text-sm font-semibold text-text-primary">
                    {language === 'en' ? 'Call Us' : 'اتصل بنا'}
                  </p>
                  <p className="text-xs text-text-secondary font-accent">6991 1181</p>
                </div>
              </a>
              <a
                href="/contact"
                className="flex items-center gap-3 p-3 bg-muted rounded-lg hover:bg-primary/10 transition-colors duration-base"
              >
                <Icon name="EnvelopeIcon" size={20} variant="solid" className="text-secondary" />
                <div>
                  <p className="text-sm font-semibold text-text-primary">
                    {language === 'en' ? 'Send Message' : 'إرسال رسالة'}
                  </p>
                  <p className="text-xs text-text-secondary">
                    {language === 'en' ? 'Contact form' : 'نموذج الاتصال'}
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LiveChatButton;